import axios from "axios";

export default {
  getFactoryLocationByStateId(selectedStateId) {
    return axios.get(`/state/factory/location/${selectedStateId}`);
  },

  getFactoryLocationByDistrictName(selectedDistrictName) {
    return axios.get(`/district/factory/location/${selectedDistrictName}`);
  }
};
